import Mutations from '../../odata/mutations';

export default { ...new Mutations('broadcastSchedule'), ...new Mutations('broadcastSchedules') };
